import { Link } from "react-router-dom";
import { SUBURB_PAGES } from "../content";
import { Reveal } from "./Reveal";

const ANCHORS = {
  "Carrum Downs": "House cleaning in Carrum Downs",
  Frankston: "Frankston house cleaning",
  Cranbourne: "House cleaners in Cranbourne",
  Langwarrin: "Langwarrin house cleaning",
  Berwick: "House cleaning in Berwick",
  Mornington: "Mornington house cleaners",
};

export const SuburbLinks = () => (
  <section data-testid="suburb-links-section" className="mx-auto max-w-7xl px-6 pb-24">
    <Reveal>
      <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <h2 className="font-display text-lg font-bold text-brand-ink">Where We Clean</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          We provide house cleaning across Melbourne's South East, including:
        </p>
        <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2.5 text-sm">
          {SUBURB_PAGES.map((s) => (
            <li key={s.slug}>
              <Link to={`/${s.slug}`} className="font-semibold text-brand-teal underline-offset-4 hover:underline">
                {ANCHORS[s.suburb] || `House cleaning in ${s.suburb}`}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Reveal>
  </section>
);
